import gwIcon from "../assets/gmicon.svg";
import mapsAndFlags from "../assets/maps-and-flags.svg";
import email from "../assets/email.svg";
import phone from "../assets/phone-call.svg";
import "../styles/home.css";

function Home() {
  return (
    <div className="App">
      <div className="App-container">
        <h1 className="App-Header-h1">GOLDWISE</h1>
        <h2 className="App-Header-h2">Buy, Manage & Sell Precious Metals</h2>
        <h3 className="App-Header-h3">
          Including: Gold, Silver, Platinum, Palladium & Rhodium
        </h3>
        <div className="App-button-blue">
          <p className="App-button-round-blue">Coming Soon</p>
        </div>
        <div className="App-buttons-grey">
          <p className="App-button-grey">Buy Gold</p>
          <p className="App-button-grey">Buy Silver</p>
          <p className="App-button-grey">Buy Platinum</p>
          <p className="App-button-grey">Buy Palladium</p>
          <p className="App-button-grey">Buy Rhodium</p>
        </div>
        <div className="App-footer">
          <h2>Get in touch:</h2>
          <ul>
            <li>
              <img src={gwIcon} className="App-icon" alt="Business" />
              GoldWise Holdings Limited (13223773)
            </li>
            <li>
              <img src={mapsAndFlags} className="App-icon" alt="Address" />
              Tramshed Tech, Pendyris Street, Cardiff, CF11 6BH
            </li>
            <li>
              <img src={phone} className="App-icon" alt="Phone" />
              <a href="tel:+44 029 2105 5383">(+44) 029 2105 5383</a>
            </li>
            <li>
              <img src={email} className="App-icon" alt="Email" />
              <a href="mailto:hello@goldwise.com">hello@goldwise.com</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Home;
